import type { FC, ReactElement } from "react";
import { type BaseFieldProps, Field, type WrappedFieldProps } from "redux-form";

import { fieldIsInvalid, fieldIsInWarnState } from "@/app-utils/form.ts";
import { FormError } from "@/ui-modules/core/form/layout/FormError.js";
import { FormInputGroup } from "@/ui-modules/core/form/layout/FormGroup.js";
import { FormInputWidget } from "@/ui-modules/core/form/layout/FormInputWidget.js";
import { FormLabel } from "@/ui-modules/core/form/layout/FormLabel.js";
import { FormWarning } from "@/ui-modules/core/form/layout/FormWarning.js";
import { type IWorkflowSelectProps, WorkflowSelect } from "@/ui-modules/core/forms/WorkflowSelect.tsx";

export interface WorkflowSelectorFormFieldProps
  extends Omit<IWorkflowSelectProps, "workflowId" | "handleChange" | "defaultSelectedWorkflowId">,
    Partial<WrappedFieldProps> {
  title?: string | ReactElement;
  forceWarnState?: string;
  tooltip?: string;
  horizontalLayout?: boolean;
}

const WorkflowSelectorFormField: FC<WorkflowSelectorFormFieldProps> = (props) => {
  //const inputClasses = clsx("form-control", { error: fieldIsInvalid(props) });

  return (
    <FormInputGroup horizontalLayout={props.horizontalLayout}>
      {!!props.title && <FormLabel>{props.title}</FormLabel>}

      <FormInputWidget tooltip={props.tooltip}>
        <WorkflowSelect
          defaultSelectedWorkflowId={props.input?.value} // remove empty string
          handleChange={(e) => {
            props.input?.onChange(e);
          }}
        />

        {fieldIsInvalid(props) && <FormError>{props.meta?.error}</FormError>}
        {(!!props.forceWarnState || fieldIsInWarnState(props)) && (
          <FormWarning>{props.forceWarnState ?? props.meta?.warning}</FormWarning>
        )}
      </FormInputWidget>
    </FormInputGroup>
  );
};

export default WorkflowSelectorFormField;

export function WorkflowSelectorReduxFormField(props: WorkflowSelectorFormFieldProps & BaseFieldProps) {
  return <Field {...props} component={WorkflowSelectorFormField} />;
}
